export enum ScaleStyle {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
}

export enum FilterType {
  DATE_RANGE = 'dateRange',
  ENTERPRISE_UNIT_IDS = 'enterpriseUnitIds',
}

export enum ReportMetric {
  FORECAST_SALES = 'forecastSales',
  LABOR_PERCENTAGE = 'laborPercentage',
  SALES_PER_LABOR_HOUR = 'salesPerLaborHour',
  NUMBER_OF_GUESTS = 'numberOfGuests',
  GUEST_CHECK_AVERAGE = 'guestCheckAverage',
  TOTAL_DISCOUNTS = 'totalDiscounts',
  TOTAL_VOIDS = 'totalVoids',
  NUMBER_OF_CHECKS = 'numberOfChecks',
  NET_SALES = 'netSales',
}
